/**
 * La conversación se sigue viendo, pero dejó de actualizarse.
 *
 * Antes un sondeo fallido reemplazaba el chat por «No se pudo abrir la
 * conversación»; ahora el chat queda y esta franja dice que lo que se ve puede
 * no estar al día. Se va sola con la primera respuesta que llegue (`hilo.ts`).
 */
export default function AvisoSinConexion() {
  return (
    <div
      role="status"
      className="flex shrink-0 items-center gap-2.5 border-b border-warn-border bg-warn-light px-[18px] py-2 text-micro text-warn-ink"
    >
      <span className="h-2 w-2 shrink-0 animate-dot rounded-full bg-warn" />
      <p className="flex-1">
        <b>Sin conexión con el servidor, reintentando…</b>{' '}
        Lo que ves puede no estar al día.
      </p>
    </div>
  )
}
